import { render, staticRenderFns } from "./EstadoProcesoDetail.vue?vue&type=template&id=d8d0948e&scoped=true"
import script from "./EstadoProcesoDetail.vue?vue&type=script&lang=js"
export * from "./EstadoProcesoDetail.vue?vue&type=script&lang=js"
import style0 from "./EstadoProcesoDetail.vue?vue&type=style&index=0&id=d8d0948e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d0948e",
  null
  
)

export default component.exports